import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import PricingService from "services/PricingService";
import Utils from "utils";
import openNotification from "utils/notification";

// DISTANCE RATES
export const getDistanceRatesApi = createAsyncThunk(
  "pricing/getDistanceRates",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PricingService.getDistanceRates();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateDistanceRatesApi = createAsyncThunk(
  "pricing/updateDistanceRates",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.updateDistanceRates(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

// TIME SURCHARGES
export const getTimeSurchargesApi = createAsyncThunk(
  "pricing/getTimeSurcharges",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PricingService.getTimeSurcharges();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateTimeSurchargesApi = createAsyncThunk(
  "pricing/updateTimeSurcharges",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.updateTimeSurcharges(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

// TRIP TYPES
export const getTripTypesApi = createAsyncThunk(
  "pricing/getTripTypes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PricingService.getTripTypes();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateTripTypesApi = createAsyncThunk(
  "pricing/updateTripTypes",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.updateTripTypes(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

// ADDON SERVICES
export const getAddonServicesApi = createAsyncThunk(
  "pricing/getAddonServices",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PricingService.getAddonServices();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createAddonServicesApi = createAsyncThunk(
  "pricing/createAddonServices",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.createAddonServices(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateAddonServicesApi = createAsyncThunk(
  "pricing/updateAddonServices",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.updateAddonServices(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteAddonServicesApi = createAsyncThunk(
  "pricing/deleteAddonServices",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.deleteAddonServices(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

// AIRPORT FEES
export const getAirportFeesApi = createAsyncThunk(
  "pricing/getAirportFees",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PricingService.getAirportFees();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createAirportFeesApi = createAsyncThunk(
  "pricing/createAirportFees",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.createAirportFees(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateAirportFeesApi = createAsyncThunk(
  "pricing/updateAirportFees",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.updateAirportFees(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteAirportFeesApi = createAsyncThunk(
  "pricing/deleteAirportFees",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.deleteAirportFees(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

// ZONE RATES — giá theo khu vực (LOGIC 02A)
export const getZoneRatesApi = createAsyncThunk(
  "pricing/getZoneRates",
  async (params, { rejectWithValue }) => {
    try {
      const response = await PricingService.getZoneRates(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createZoneRateApi = createAsyncThunk(
  "pricing/createZoneRate",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.createZoneRate(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateZoneRateApi = createAsyncThunk(
  "pricing/updateZoneRate",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.updateZoneRate(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const bulkUpsertZoneRateApi = createAsyncThunk(
  "pricing/bulkUpsertZoneRate",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.bulkUpsertZoneRate(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteZoneRateApi = createAsyncThunk(
  "pricing/deleteZoneRate",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id, silent } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      delete payload.silent;
      const response = await PricingService.deleteZoneRate(id);
      if (onSuccess) onSuccess(response);
      if (!silent)
        openNotification(
          "success",
          Utils.setLocale("admin.settings.popup.notification.success"),
          Utils.setLocale("admin.settings.popup.notification.title"),
        );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

// RADIUS RATES — giá theo bán kính (LOGIC 02B)
export const getRadiusRatesApi = createAsyncThunk(
  "pricing/getRadiusRates",
  async (params, { rejectWithValue }) => {
    try {
      const response = await PricingService.getRadiusRates(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createRadiusRateApi = createAsyncThunk(
  "pricing/createRadiusRate",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.createRadiusRate(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateRadiusRateApi = createAsyncThunk(
  "pricing/updateRadiusRate",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.updateRadiusRate(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const bulkUpsertRadiusRateApi = createAsyncThunk(
  "pricing/bulkUpsertRadiusRate",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.bulkUpsertRadiusRate(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteRadiusRateApi = createAsyncThunk(
  "pricing/deleteRadiusRate",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.deleteRadiusRate(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

// MINIMUM PRICES — giá sàn
export const getMinimumPricesApi = createAsyncThunk(
  "pricing/getMinimumPrices",
  async (params, { rejectWithValue }) => {
    try {
      const response = await PricingService.getMinimumPrices(params);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const upsertMinimumPriceApi = createAsyncThunk(
  "pricing/upsertMinimumPrice",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, silent } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      delete payload.silent;
      const response = await PricingService.upsertMinimumPrice(payload);
      if (onSuccess) onSuccess(response);
      if (!silent)
        openNotification(
          "success",
          Utils.setLocale("admin.settings.popup.notification.success"),
          Utils.setLocale("admin.settings.popup.notification.title"),
        );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteMinimumPriceApi = createAsyncThunk(
  "pricing/deleteMinimumPrice",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id, silent } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      delete payload.silent;
      const response = await PricingService.deleteMinimumPrice(id);
      if (onSuccess) onSuccess(response);
      // silent = true khi gọi hàng loạt, component tự hiện 1 thông báo tổng
      if (!silent)
        openNotification(
          "success",
          Utils.setLocale("admin.settings.popup.notification.success"),
          Utils.setLocale("admin.settings.popup.notification.title"),
        );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

// HOLIDAY SURCHARGE
export const getHolidaySurchargeApi = createAsyncThunk(
  "pricing/getHolidaySurcharge",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PricingService.getHolidaySurcharge();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateHolidaySurchargeApi = createAsyncThunk(
  "pricing/updateHolidaySurcharge",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.updateHolidaySurcharge(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

// TOLL ROUTES
export const getTollRoutesApi = createAsyncThunk(
  "pricing/getTollRoutes",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PricingService.getTollRoutes();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createTollRoutesApi = createAsyncThunk(
  "pricing/createTollRoutes",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.createTollRoutes(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateTollRoutesApi = createAsyncThunk(
  "pricing/updateTollRoutes",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.updateTollRoutes(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const deleteTollRoutesApi = createAsyncThunk(
  "pricing/deleteTollRoutes",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.deleteTollRoutes(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

// VAT SETTING
export const getVatSettingApi = createAsyncThunk(
  "pricing/getVatSetting",
  async (_, { rejectWithValue }) => {
    try {
      const response = await PricingService.getVatSetting();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateVatSettingApi = createAsyncThunk(
  "pricing/updateVatSetting",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.updateVatSetting(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

//PRICING CALCULATE
export const calculatePriceApi = createAsyncThunk(
  "pricing/calculatePrice",
  async (data, { rejectWithValue }) => {
    const { onSuccess } = data;
    try {
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await PricingService.calculatePrice(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  distanceRatesList: [],
  timeSurchargesList: [],
  tripTypesList: [],
  addonServiceList: [],
  airportFeeList: [],
  holidaySurcharge: {},
  tollRoutesList: [],
  zoneRatesList: [],
  radiusRatesList: [],
  minimumPricesList: [],
  vatSetting: {},
  calculateResult: {},
};

export const pricingSlice = createSlice({
  name: "pricing",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      // DISTANCE RATES
      .addCase(getDistanceRatesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDistanceRatesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.distanceRatesList = action.payload;
      })
      .addCase(getDistanceRatesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateDistanceRatesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateDistanceRatesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateDistanceRatesApi.rejected, (state, action) => {
        state.loading = false;
      })

      // TIME SURCHARGES
      .addCase(getTimeSurchargesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTimeSurchargesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.timeSurchargesList = action.payload;
      })
      .addCase(getTimeSurchargesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateTimeSurchargesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTimeSurchargesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateTimeSurchargesApi.rejected, (state, action) => {
        state.loading = false;
      })

      // TRIP TYPES
      .addCase(getTripTypesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTripTypesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.tripTypesList = action.payload;
      })
      .addCase(getTripTypesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateTripTypesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTripTypesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateTripTypesApi.rejected, (state, action) => {
        state.loading = false;
      })

      // ADDON SERVICES
      .addCase(getAddonServicesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAddonServicesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.addonServiceList = action.payload;
      })
      .addCase(getAddonServicesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createAddonServicesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(createAddonServicesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createAddonServicesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateAddonServicesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAddonServicesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateAddonServicesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteAddonServicesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAddonServicesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteAddonServicesApi.rejected, (state, action) => {
        state.loading = false;
      })

      // AIRPORT FEES
      .addCase(getAirportFeesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAirportFeesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.airportFeeList = action.payload;
      })
      .addCase(getAirportFeesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createAirportFeesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(createAirportFeesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createAirportFeesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateAirportFeesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateAirportFeesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateAirportFeesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteAirportFeesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteAirportFeesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteAirportFeesApi.rejected, (state, action) => {
        state.loading = false;
      })

      // HOLIDAY SURCHARGE
      .addCase(getHolidaySurchargeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHolidaySurchargeApi.fulfilled, (state, action) => {
        state.loading = false;
        state.holidaySurcharge = action.payload;
      })
      .addCase(getHolidaySurchargeApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateHolidaySurchargeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateHolidaySurchargeApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateHolidaySurchargeApi.rejected, (state, action) => {
        state.loading = false;
      })

      // TOLL ROUTES
      .addCase(getTollRoutesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTollRoutesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.tollRoutesList = action.payload;
      })
      .addCase(getTollRoutesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createTollRoutesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(createTollRoutesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createTollRoutesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateTollRoutesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTollRoutesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateTollRoutesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteTollRoutesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTollRoutesApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteTollRoutesApi.rejected, (state, action) => {
        state.loading = false;
      })

      // VAT SETTING
      .addCase(getVatSettingApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getVatSettingApi.fulfilled, (state, action) => {
        state.loading = false;
        state.vatSetting = action.payload;
      })
      .addCase(getVatSettingApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateVatSettingApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateVatSettingApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateVatSettingApi.rejected, (state, action) => {
        state.loading = false;
      })

      // ZONE RATES
      .addCase(getZoneRatesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getZoneRatesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.zoneRatesList = action.payload;
      })
      .addCase(getZoneRatesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createZoneRateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(createZoneRateApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createZoneRateApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateZoneRateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateZoneRateApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateZoneRateApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(bulkUpsertZoneRateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(bulkUpsertZoneRateApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(bulkUpsertZoneRateApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteZoneRateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteZoneRateApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteZoneRateApi.rejected, (state, action) => {
        state.loading = false;
      })

      // RADIUS RATES
      .addCase(getRadiusRatesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRadiusRatesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.radiusRatesList = action.payload;
      })
      .addCase(getRadiusRatesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(createRadiusRateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(createRadiusRateApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createRadiusRateApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateRadiusRateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateRadiusRateApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateRadiusRateApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(bulkUpsertRadiusRateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(bulkUpsertRadiusRateApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(bulkUpsertRadiusRateApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteRadiusRateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteRadiusRateApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteRadiusRateApi.rejected, (state, action) => {
        state.loading = false;
      })

      // MINIMUM PRICES
      .addCase(getMinimumPricesApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getMinimumPricesApi.fulfilled, (state, action) => {
        state.loading = false;
        state.minimumPricesList = action.payload;
      })
      .addCase(getMinimumPricesApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(upsertMinimumPriceApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(upsertMinimumPriceApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(upsertMinimumPriceApi.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(deleteMinimumPriceApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteMinimumPriceApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(deleteMinimumPriceApi.rejected, (state, action) => {
        state.loading = false;
      })

      //PRICING CALCULATE
      .addCase(calculatePriceApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(calculatePriceApi.fulfilled, (state, action) => {
        state.loading = false;
        state.calculateResult = action.payload;
      })
      .addCase(calculatePriceApi.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = pricingSlice.actions;
export default pricingSlice.reducer;